import classNames from 'classnames';
import { InputHTMLAttributes } from 'react';

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  inputClassName?: string;
  error?: string | boolean;
  checked: boolean;
  label?: string | React.ReactElement;
  labelRef?: React.RefObject<HTMLLabelElement | null>;
  ref?: React.RefObject<HTMLInputElement | null>;
}

function Checkbox({
  className,
  inputClassName,
  checked,
  label,
  error,
  labelRef,
  ref: inputRef,
  disabled = false,
  ...rest
}: CheckboxProps) {
  return (
    <label
      className={classNames(
        'group',
        'inline-flex flex-1 flex-row items-center',
        !disabled && !rest.readOnly && 'cursor-pointer',
        className,
        label && error && 'text-red-600'
      )}
      ref={labelRef}
    >
      <input
        type="checkbox"
        className={classNames(
          "h-5 w-5 flex-shrink-0 appearance-none rounded border border-neutral-500 before:content-['']",
          'checked:border-4 checked:border-white checked:bg-green-800 checked:ring-2 checked:ring-green-400',
          label && 'mr-2',
          inputClassName
        )}
        checked={checked}
        disabled={disabled}
        ref={inputRef}
        {...rest}
      />
      <span
        className={classNames(
          'border-b border-b-transparent leading-none',
          !disabled && !rest.readOnly && 'group-hover:border-b-neutral-800'
        )}
      >
        {label}
      </span>
    </label>
  );
}

export default Checkbox;
